import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { AuthTokenBundle, ImpersonatableUsers, Page } from "@/services/bedrock/dtos";

const IMPERSONATION_SERVICE = `${Constants.API_URL}/bedrock/impersonations`;

export interface ImpersonationFilterParams {
  search?: string;
  page?: number;
  perPage?: number;
}

export class ImpersonationServices {
  @scCatchServiceException()
  static async getImpersonatableUsers(params?: ImpersonationFilterParams): Promise<Page<ImpersonatableUsers>> {
    const { data } = await axios.get<Page<ImpersonatableUsers>>(IMPERSONATION_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async impersonateUser(userGuid: string): Promise<AuthTokenBundle> {
    const { data } = await axios.post<AuthTokenBundle>(IMPERSONATION_SERVICE, { guid: userGuid });
    return data;
  }

  @scCatchServiceException()
  static async revertImpersonation(): Promise<AuthTokenBundle> {
    const { data } = await axios.post<AuthTokenBundle>(`${IMPERSONATION_SERVICE}/revert`);
    return data;
  }
}
